import useTranslator from "../../hooks/useTranslator";
import {
  OutlineShieldIcon,
  MailIcon,
  BuildingIcon,
} from "../../helper/svgHelper";

const InsuranceActivatedPopup = ({
  show,
  onClose,
  onDone,
  propertyData,
  forceConfirmed,
}) => {
  const { _t } = useTranslator();

  if (!show) return null;

  const insuranceData = propertyData?.insurance_data;
  const isConfirmed = forceConfirmed || insuranceData?.status === "confirmed";

  return (
    <div
      className="popup-overlay fixed inset-0 d-flex align-items-center justify-content-center z-50 wrapper-modal"
      style={{ zIndex: 9999 }}
    >
      <div className="ins-activated-card">
        <button className="ins-activated-close" onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>

        <div className="ins-activated-icon-wrap">
          <OutlineShieldIcon />
        </div>

        {isConfirmed ? (
          <>
            <h2 className="ins-activated-heading">
              {_t("insuranceOnTheWayHeading")}
            </h2>
            <p className="ins-activated-subheading">
              {_t("insuranceOnTheWaySubheading")}
            </p>

            <div className="ins-activated-info-box">
              <div className="ins-activated-info-row">
                <span className="ins-activated-info-icon">
                  <MailIcon size={18} />
                </span>
                <span className="ins-activated-info-text">
                  {_t("insuranceEmailInfo")}
                </span>
              </div>
              <div className="ins-activated-info-row">
                <span className="ins-activated-info-icon">
                  <BuildingIcon size={18} />
                </span>
                <span className="ins-activated-info-text">
                  {_t("insuranceDashboardInfo")}
                </span>
              </div>
            </div>

            <button
              className="btnNext addGuarantorButton ins-activated-btn-back"
              onClick={onDone}
            >
              {_t("backToProperty")}
            </button>
          </>
        ) : (
          <>
            <h2 className="ins-activated-heading">
              {_t("processingInsurance")}
            </h2>
            <p className="ins-activated-subheading">
              {_t("processingTheInsurance")}
            </p>

            <div className="ins-activated-processing-wrap">
              <div className="ins-activated-spinner" />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default InsuranceActivatedPopup;
